var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11,1 C11.5522847,1 12,1.44771525 12,2 L12,3 L13,3 C14.1045695,3 15,3.8954305 15,5 L15,12 C15,13.1045695 14.1045695,14 13,14 L3,14 C1.8954305,14 1,13.1045695 1,12 L1,5 C1,3.8954305 1.8954305,3 3,3 L4,3 L4,2 C4,1.44771525 4.44771525,1 5,1 C5.55228475,1 6,1.44771525 6,2 L6,3 L10,3 L10,2 C10,1.44771525 10.4477153,1 11,1 Z M13,7 L3,7 L3,11.5 C3,11.7761424 3.22385763,12 3.5,12 L3.5,12 L12.5,12 C12.7761424,12 13,11.7761424 13,11.5 L13,11.5 L13,7 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.e79ceb42338ac61e31e29e6ec54eb291.svg";
export { ForwardRef as ReactComponent };